import * as React from "react";
import * as Highlighter from "react-highlight-words";
import { LocStoreInstance } from ".";
import { UserInfo } from "../WSUtils/UserInfo";
import { isLocalhost } from "../WSUtils/isLocalhost";
import { lp } from "../WSUtils/logPrefix";
import { ITextAndTranslation } from "../api/translations/getStringsAndTranslations";
import { getTranslationPreviewKey } from "./translationPreviewPrefix";

const getPreviewOverride = (
  userInfo: UserInfo,
  frontendId: string,
  locale: string
) => {
  return userInfo.settings[getTranslationPreviewKey(frontendId, locale)];
};

const getTranslatedText = (
  inputText: string,
  searchWords: string[],
  stringContext: string,
  id: string,
  userInfo: UserInfo,
  locStoreInstance: LocStoreInstance
) => {
  if (typeof inputText !== "string") {
    console.error(lp(), `String for translation must be of type string ${id}`);
  }

  if (inputText.startsWith(" ") || inputText.endsWith(" ")) {
    console.error(lp(), `Translation of padded string not supported ${id}`);
  }

  let TT: ITextAndTranslation;

  const translationsLoaded = !!locStoreInstance.gotTranslationsForLocale;

  if (translationsLoaded) {
    TT = locStoreInstance.getTranslation(id, inputText, stringContext);
  }

  const found = translationsLoaded && TT;
  const match = found && inputText === TT.text;

  const canUseTranslation = match && !!TT.translated;

  let translatedText = canUseTranslation ? TT.translated : inputText;

  if (translationsLoaded && !found) {
    console.error(
      lp(),
      `Translation not found for [${stringContext}]${id} ${inputText}`
    );
  }

  if (translationsLoaded && found && !match) {
    console.error(
      lp(),
      `Source for [${stringContext}]${id} does not match`,
      `InputText=${inputText}`,
      `Source=${TT.text}`
    );
  }

  if (!translationsLoaded) {
    return "";
  }

  return translatedText;
};

export function loc(
  inputText: string,
  searchWords: string[],
  stringContext: string,
  id: string,
  userInfo: UserInfo,
  locStoreInstance: LocStoreInstance
): any {
  let translatedText = getPreviewOverride(userInfo, id, userInfo.locale);

  if (!translatedText) {
    translatedText = getTranslatedText(
      inputText,
      searchWords,
      stringContext,
      id,
      userInfo,
      locStoreInstance
    );
  }

  if (searchWords) {
    return (
      <Highlighter
        searchWords={searchWords}
        autoEscape
        textToHighlight={translatedText}
      />
    );
  }

  return translatedText;
}
